// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"4971e30b","388":"4971e30b","465":"4971e30b","758":"4971e30b","986":"4971e30b"}[chunkId] + ".chunk.css";
};